import { parse } from 'yaml';

const dataBase = '/data/';

function sortByProperty<T extends object>(
  list: T[],
  orderByProperty: keyof T & string
): T[] {
  return [...list].sort((a, b) => {
    const left = a[orderByProperty];
    const right = b[orderByProperty];
    if (typeof left === 'string' && typeof right === 'string') {
      return left.localeCompare(right);
    }
    return 0;
  });
}

export async function getYamlList<T extends object>(
  fileName: string,
  orderByProperty?: keyof T & string
): Promise<T[]> {
  try {
    const response = await fetch(`${dataBase}${fileName}`);
    if (!response.ok) return [];
    const yaml = await response.text();
    const list = (parse(yaml) as T[]) ?? [];
    if (orderByProperty) {
      return sortByProperty(list, orderByProperty);
    }
    return list;
  } catch {
    return [];
  }
}

export async function getYaml<T>(fileName: string): Promise<T | null> {
  try {
    const response = await fetch(`${dataBase}${fileName}`);
    if (!response.ok) return null;
    const yaml = await response.text();
    return parse(yaml) as T;
  } catch {
    return null;
  }
}
